import React, { Component, PropTypes } from 'react'
import {partial} from 'lodash'
import classNames from 'classnames'

import StampChooser from './StampChooser'
import ControlledSelect from './ControlledSelect'
import Price from 'components/Price'

class WeightChooser extends Component {
    constructor() {
        super()
      this.state = { engravingMode: '0' }
    }
 
    componentWillReceiveProps(nextProps) {
        this.state = { engravingMode: '0' }
    }
  
    handleEngravingCheck(chk) {
        const weight = this.props.weight;
        const keys = weight.keys;

        this.props.onFieldChange(keys.weightEngravingToe, 0);
        this.props.onFieldChange(keys.weightEngravingHeel, 0);

        if(chk.checked)
        {
            this.props.onFieldChange(keys.weightEngraving, weight.engravingOption.id)
        }
        else
        {
            this.props.onFieldChange(keys.weightEngraving, 0);
        }
    }

    handleEngravingStyle(radio) {
        const weight = this.props.weight;
        const keys = weight.keys;

        this.props.onFieldChange(keys.weightEngravingToe, 0);
        this.props.onFieldChange(keys.weightEngravingHeel, 0);

        if (radio.value === weight.engravingOption2.id.toString()) {
            this.props.onFieldChange(keys.weightEngraving, weight.engravingOption2.id);
        } else {
            this.props.onFieldChange(keys.weightEngraving, weight.engravingOption.id);
        }
    }

    handleWeightChange(selectVal) {
        const weight = this.props.weight;
        const keys = weight.keys;

        if (selectVal == '' || selectVal == '0') {
            this.props.onFieldChange(keys.weightEngraving, 0);
            this.props.onFieldChange(keys.weightEngravingToe, 0);
            this.props.onFieldChange(keys.weightEngravingHeel, 0);
        }
        weight.selected = selectVal;
        this.props.onFieldChange(keys.weight, selectVal);

    }

  render() {
    const { weight, hasEngraving, onFieldChange, onSelectPaintFill, isError, isStampError, isPaintError, allowKeepAsIs } = this.props;
    const keys = weight.keys
    return (
      <div className={classNames("weight-chooser")}>
        <ControlledSelect
          showPrice={!!weight.weights[0].price}
          options={weight.weights}
          selected={weight.selected || (allowKeepAsIs ? "" : weight.weights[0])}
          onChange={(val) => this.handleWeightChange(val)}
          isError={isError}
        >
          {allowKeepAsIs &&
           <option value="">Keep As Is</option>
          }
        </ControlledSelect>
        <div>
        
        {hasEngraving && weight.engravingOption && weight.selected &&
                 <div>   
                    <div className={classNames("customize-form-section-header")}>Weight Engraving</div>
                    <div>
                        <div className="side-checkbox">
                            <label className={(weight.selectedEngraving != null ? 'option-selected' : '')}>
                                <div className={(weight.selectedEngraving != null ? 'option-selected' : '') + ' checkbox-target'}> </div>
                                <input type="checkbox" id="toeWeightEngravingOption" checked={weight.selectedEngraving != null} onChange={(evt) => this.handleEngravingCheck(evt.target)} />
                                Weight Engraving
                                {weight.engravingOption.price > 0 &&
                                    <span> - ${weight.engravingOption.price}</span>
                                }
                            </label>
                        </div>
                        {weight.selectedEngraving != null && weight.engravingOption && weight.engravingOption2 &&
                            <div>
                                <div class="letter-style-text">Paintfill Style</div>
                                <div className={"engraving-style-options"}>
                <div key={"engraving1"} className="side-radio">
                                    <label className={"radio-select " + (weight.selectedEngraving.id != weight.engravingOption2.id ? 'option-selected' : '')}>
                                        <div className={((weight.selectedEngraving.id != weight.engravingOption2.id) ? 'option-selected ' : '') + "radio-target"} ></div>
                  <input type="radio" name="engravingType"
                                            value={weight.engravingOption.id}
                                            onChange={(evt) => this.handleEngravingStyle(evt.target)}
                    checked={weight.selectedEngraving.id != weight.engravingOption2.id}
                  />
                                            <img src="https://acushnet.scene7.com/is/image/scottycameron/Dog_CENTER_C?fmt=png-alpha&wid=40" alt="Weight Center" />
                                            <span>{weight.engravingOption.label}</span>
                    
                </label>
                </div>                
                    <div key={"engraving2"} className="side-radio">
                      <label className={"radio-select " + (weight.selectedEngraving.id == weight.engravingOption2.id ? 'option-selected' : '')}>
                      <div className={((weight.selectedEngraving.id == weight.engravingOption2.id) ? 'option-selected ' : '') + "radio-target"} ></div>
                      <input type="radio" name="engravingType"
                                            value={weight.engravingOption2.id}
                                            onChange={(evt) => this.handleEngravingStyle(evt.target)}
                        checked={weight.selectedEngraving.id == weight.engravingOption2.id}
                                        />
                                            <img src="https://acushnet.scene7.com/is/image/scottycameron/Weights_Dog_Engraving?fmt=png-alpha&wid=40" alt="Engraving Only" />

                                            <span>{weight.engravingOption2.label}</span>
                                    </label>
                                </div>
                                </div>
            <StampChooser noCheck stampLoc={weight.frontEngraving.loc}
              selectedStamp={weight.frontEngraving.selected}
              stamps={weight.frontEngraving.stamps}
              onSelectStamp={(stampId) => onFieldChange(keys.weightEngravingToe, stampId)}
              paintLoc={weight.frontPaint.loc}
              selectedPaint={weight.frontPaint.selected}
              paints={weight.frontPaint.paints}
              isError={isStampError && !weight.frontEngraving.valid}
              isPaintError={isPaintError && !weight.frontPaint.valid}
              onSelectPaintFill={(locid, paintid) => onSelectPaintFill(locid, paintid)}
              selectedWeight={weight.selected}
            />
          
            <StampChooser noCheck stampLoc={weight.rearEngraving.loc}
              selectedStamp={weight.rearEngraving.selected}
              stamps={weight.frontEngraving.stamps}
              onSelectStamp={(stampId) => onFieldChange(keys.weightEngravingHeel, stampId)}
              paintLoc={weight.rearPaint.loc}
              selectedPaint={weight.rearPaint.selected}
              paints={weight.rearPaint.paints}
              isError={isStampError && !weight.rearEngraving.valid}
              isPaintError={isPaintError && !weight.rearPaint.valid}
              onSelectPaintFill={(locid, paintid) => onSelectPaintFill(locid, paintid)}
              selectedWeight={weight.selected}
            />
                        </div>
                        }
                        </div>
                 </div>
          } 
          
        </div>
        
        </div>
    )
  }
}

let engravingShape = PropTypes.shape({
  loc:PropTypes.object.isRequired,
  selected:PropTypes.object,
  stamps:PropTypes.arrayOf(PropTypes.object).isRequired, 
}).isRequired;
let paintShape = PropTypes.shape({
  loc:PropTypes.object.isRequired,
  selected:PropTypes.object,
  paints:PropTypes.arrayOf(PropTypes.object).isRequired, 
}).isRequired;

WeightChooser.propTypes = {
  weight: PropTypes.shape({
    frontEngraving: engravingShape,
    rearEngraving: engravingShape,
    frontPaint: paintShape,
    rearPaint: paintShape, 
  }).isRequired,
  hasEngraving: PropTypes.bool.isRequired,
  isError: PropTypes.bool,
  isStampError: PropTypes.bool,
  isPaintError: PropTypes.bool,
  onFieldChange: PropTypes.func.isRequired,
  onSelectPaintFill: PropTypes.func.isRequired,
}

export default WeightChooser